module.exports = __webpack_public_path__ + "static/media/kenai-logo-light.6b8f7582.svg";